const reduceByKey = (array, key = 'id') => array.reduce((acc, value) => {
  acc[value[key]] = value
  return acc
}, {})

export default reduceByKey
